import React, { useState } from 'react'
import ReportLayout from './ReportLayout'
import Breadcrumb from '../../../Components/Utils/Breadcrumb'
import { TextMediumSM } from '../../../Components/Text/MediumText'
import { Link } from 'react-router-dom'
import { GetAccess } from '../../../Components/Utils/roles'



function ReportIndex() {
      const [selectedValues, setSelectedValues] = useState("")
      const [show,setShow] = useState("")
    
      function handleChange(e){
        setSelectedValues(e.value)
      }
    
    
      const styles = {
        control: (provided) => ({
          ...provided,
    
          border: "1px solid #e5e5e5",
          outline: "none",
          borderRadius: "10px",
          padding: "0",
          color: "#000",
          textAlign: "left",
          // fontSize:'13px',
          fontWeight: "500",
          width: "100%",
          // zIndex:0
        }),
      };
    
    
    
    
     let ClientManagementOptions = [
  {
    label: "Client",
    value: 1,
    link: '/report/client-Management/client',
    key: "report_client",
  },
  {
    label: "Survey Report",
    value: 1,
    link: '/report/client-Management/survey-report',
    key: "report_survey",
  },
  {
    label: "Contract",
    value: 1,
    link: '/report/client-Management/contract',
    key: "report_contract",
  },
]

          let InspectionOptions = [
            {
              label: "Schedule",
              value:1,
              link:'/report/inspection/inschedule',
              key:'report_inspection_scheule'
            },
          //   {
          //     label: "Purchase Order",
          //     value:1,
          //     link:'/reports/procurement/purchase-order'
          //   },
          ]

          let CommisionOptions = [
            {
              label: "Schedule",
              value:1,
              link:'/report/commisioning/schedule',
              key:'report_commisioning_schedule'
            },
          //   {
          //     label: "Purchase Order",
          //     value:1,
          //     link:'/reports/procurement/purchase-order'
          //   },
          ]

          let RefillingOptions = [
            {
              label: "Fire Extinguisher",
              value:1,
              link:'/report/refilling/fireExtinguisher',
              key:'report_refilling_ext'
            },
            {
              label: "Fire Suppression",
              value:1,
              link:'/report/refilling/fireSuppression',
              key:'report_refilling_sup'
            },
          ]

          let TicketsOptions = [
            {
              label: "Client Tickets",
              value:1,
              link:'/report/tickets/clientTickets',
              key:'report_ticket_client'
            },
            {
              label: "Support Tickets",
              value:1,
              link:'/report/tickets/supportTickets',
              key:'report_ticket_support'
            },
          ]

          let TaskOptions = [
            {
              label: "Task",
              value:1,
              link:'/report/task',
              key:'report_task_task'
            },
          //   {
          //     label: "Purchase Order",
          //     value:1,
          //     link:'/reports/procurement/purchase-order'
          //   },
          ]

          let InvoiceOptions = [
            {
              label: "Outgoing",
              value:1,
              link:'/report/invoice/outgoing',
              key:'report_invoice_outgoing'
            },
          //   {
          //     label: "Purchase Order",
          //     value:1,
          //     link:'/reports/procurement/purchase-order'
          //   },
          ]
    
    
      function handleSubmit(){
        if(selectedValues){
          setShow(selectedValues)
        }else{
          setShow("")
        }
      }
    
      return (
            <ReportLayout>
        <div className=' w-full   mt-0.5   md:overflow-hidden'>
            {/* <Breadcrumb
             items={[
                {
                    name:"Report"
                }
             ]}
            /> */}
            <div className=" w-[100%] h-[calc(100vh-160px)]  bg-white rounded-md  overflow-y-auto p-3">
              
              <div className=' w-full sm:h-full sm:grid grid-cols-3 lg:grid-cols-4 gap-3 overflow-y-auto mt-5'>
               {(
  GetAccess('report_client_management') || 
  GetAccess('report_client') || 
  GetAccess('report_survey') || 
  GetAccess('report_contract')
) && (
  <div>
    <p className='px-4 py-1 bg-baseColor-primary text-white font-medium text-sm 2xl:text-base mb-4 rounded-lg'>Client Management</p>
    {
      ClientManagementOptions && ClientManagementOptions.map((item, index) => {
        return (
          GetAccess(item?.key) && (
            <div key={index} className='bg-slate-50 p-2 flex my-1 items-center rounded-lg hover:shadow-lg'>
              <Link to={item.link}>
                <TextMediumSM content={item.label || ""} />
              </Link>
            </div>
          )
        )
      })
    }
  </div>
)}

 {(
  GetAccess('report_inspection') || 
  GetAccess('report_inspection_scheule') 
 
) && (
                <div className=' mt-5 sm:mt-0'>
                <p className=' px-4 py-1 bg-baseColor-primary text-white font-medium text-sm 2xl:text-base mb-4 rounded-lg'>Inspection</p>
                {
                  InspectionOptions && InspectionOptions.map((item,index)=>{
                    return (
                      GetAccess(item?.key) && (
                      <div key={index} className=' bg-slate-50 p-2 flex my-1 items-center rounded-lg hover:shadow-lg'>
                        <Link to={item.link}>
                          <TextMediumSM content={item.label||""} />
                        </Link>
                      </div>)
                    )
                  })
                }
                </div>)}
{(
  GetAccess('report_commisioning') || 
  GetAccess('report_commisioning_schedule') 
 
) && (
                <div className=' mt-5 sm:mt-0'>
                <p className=' px-4 py-1 bg-baseColor-primary text-white font-medium text-sm 2xl:text-base mb-4 rounded-lg'>Commisioning</p>
                {
                  CommisionOptions && CommisionOptions.map((item,index)=>{
                    return (
                      GetAccess(item?.key) && (
                      <div key={index} className=' bg-slate-50 p-2 flex my-1 items-center rounded-lg hover:shadow-lg'>
                        <Link to={item.link}>
                          <TextMediumSM content={item.label||""} />
                        </Link>
                      </div>)
                    )
                  })
                }
                </div>)}
{(
  GetAccess('report_refilling') || 
  GetAccess('report_refilling_ext') ||
  GetAccess('report_refilling_sup')
 
) && (
                <div className=' mt-5 sm:mt-0'>
                <p className=' px-4 py-1 bg-baseColor-primary text-white font-medium text-sm 2xl:text-base mb-4 rounded-lg'>Refilling</p>
                {
                  RefillingOptions && RefillingOptions.map((item,index)=>{
                    return (
                      GetAccess(item?.key) && (
                      <div key={index} className=' bg-slate-50 p-2 flex my-1 items-center rounded-lg hover:shadow-lg'>
                        <Link to={item.link}>
                          <TextMediumSM content={item.label||""} />
                        </Link>
                      </div>)
                    )
                  })
                }
                </div>)}
{(
  GetAccess('report_ticket') || 
  GetAccess('report_ticket_support') ||
  GetAccess('report_ticket_client')
 
) && (
                <div className=' mt-5 sm:mt-0'>
                <p className=' px-4 py-1 bg-baseColor-primary text-white font-medium text-sm 2xl:text-base mb-4 rounded-lg'>Tickets</p>
                {
                  TicketsOptions && TicketsOptions.map((item,index)=>{
                    return (
                      GetAccess(item?.key) && (
                      <div key={index} className=' bg-slate-50 p-2 flex my-1 items-center rounded-lg hover:shadow-lg'>
                        <Link to={item.link}>
                          <TextMediumSM content={item.label||""} />
                        </Link>
                      </div>)
                    )
                  })
                }
                </div>)}
{(
  GetAccess('report_task_task') || 
  GetAccess('report_task') 
 
) && (
                <div className=' mt-5 sm:mt-0'>
                <p className=' px-4 py-1 bg-baseColor-primary text-white font-medium text-sm 2xl:text-base mb-4 rounded-lg'>Task</p>
                {
                  TaskOptions && TaskOptions.map((item,index)=>{
                    return (
                      GetAccess(item?.key) && (
                      <div key={index} className=' bg-slate-50 p-2 flex my-1 items-center rounded-lg hover:shadow-lg'>
                        <Link to={item.link}>
                          <TextMediumSM content={item.label||""} />
                        </Link>
                      </div>)
                    )
                  })
                }
                </div>)}
{(
  GetAccess('report_invoice    ') || 
  GetAccess('report_invoice_outgoing ') 
 
) && (
                <div className=' mt-5 sm:mt-0'>
                <p className=' px-4 py-1 bg-baseColor-primary text-white font-medium text-sm 2xl:text-base mb-4 rounded-lg'>Invoice</p>
                {
                  InvoiceOptions && InvoiceOptions.map((item,index)=>{
                    return (
                      GetAccess(item?.key) && (
                      <div key={index} className=' bg-slate-50 p-2 flex my-1 items-center rounded-lg hover:shadow-lg'>
                        <Link to={item.link}>
                          <TextMediumSM content={item.label||""} />
                        </Link>
                      </div>)
                    )
                  })
                }
                </div>)}
                
               
              </div>
              
            </div>
        </div>
        </ReportLayout>
      )
}

export default ReportIndex
